import { Form, Input, InputNumber, Rate, Select } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { useWatch } from 'antd/es/form/Form';
import { useEffect, useState } from 'react';
import { QuestionType } from '../models';
import { surveyStore } from 'stores/root_store';

type rateProps = {
  restField: {
    fieldKey?: number | undefined;
  };
  form: FormInstance;
  questionIdx: number;
  isChamDiem?: boolean;
  index: number;
  sessionId?: string;
};

const RateAnswer = ({ restField, index, questionIdx, form, sessionId }: rateProps) => {

  const type = useWatch(['questions', questionIdx, 'type'], form);

  const sessionIdx = surveyStore.sessions?.findIndex((i) => i.id === sessionId) as number;
  const sessions = surveyStore.sessions?.filter((item, index) => index > sessionIdx);

  const [nameLabel, setNameLabel] = useState('')
  useEffect(() => {
    switch (index) {
      case 0:
        setNameLabel('Rất kém')
        break;
      case 1:
        setNameLabel('Kém')
        break;
      case 2:
        setNameLabel('Bình thường')
        break;
      case 3:
        setNameLabel('Hài lòng')
        break;
      case 4:
        setNameLabel('Rất hài lòng')
        break;
      default:
        break;
    }
  }, [])

  const hasPoint = useWatch(['questions', questionIdx, 'hasPoint'], form);
  return (
    <div className="flex gap-5 flex-col md:flex-row">
      <Form.Item
        {...restField}
        label={nameLabel}
        name={[index, 'title']}
        className="md:w-1/4 md:ml-4 p-0 m-0 !mb-2"
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 24 }}
      >
        <Rate disabled />
      </Form.Item>

      {type === QuestionType.RATE && (
        <Form.Item {...restField} wrapperCol={{ span: 24 }} className="!mb-2" name={[index, 'part']}>
          <Select
            size="small"
            className="!w-[200px]"
            fieldNames={{ label: 'name', value: 'id' }}
            options={sessions}
            placeholder="Chọn phần"
            notFoundContent={<div className='text-center h-6 text-gray-500'>Vui lòng thêm phần</div>}
          />
        </Form.Item>
      )}

      <Form.Item className="m-0 p-0 !mb-2" wrapperCol={{ span: 24 }} name={[index, 'score']}>
        <InputNumber size="small" disabled={!hasPoint} placeholder="Nhập điểm" />
      </Form.Item>
      <Form.Item hidden className="m-0 p-0 !mb-2" wrapperCol={{ span: 24 }} name={[index, 'id']}>
        <Input />
      </Form.Item>
    </div>
  );
};

export default RateAnswer;
